import { Box } from "@mui/material";
import { RatePlanOrAttributesColumn } from "../../Utils/RatePlanColumn";
import { formatCellValue, formatDateForDisplay } from "../../Utils/UtilityFunctions";
import StatusBadge from "../../Customers/StatusBadge";
import { Tooltip } from "reactstrap";
import { useState } from "react";

export const policyColumns = (formattedDates) => {
  const column = [
    {
      accessorKey: 'id',
      header: "Policy ID",
      id: 'policy',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "name",
      header: "Policy Name",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "priority",
      header: "Priority",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },

    {
      accessorKey: "partnerNames",
      header: "Partners",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        if (!Array.isArray(value) || value.length === 0) return "-";

        const displayText =
          value.length > 1 ? `${value[0]}, ...` : value[0];

        const tooltipId = `partner-tooltip-${cell.row.id}`;
        const [tooltipOpen, setTooltipOpen] = useState(false);

        return (
          <Box>
            <span id={tooltipId} style={{ cursor: value.length > 1 ? "pointer" : "auto" }}>
              {displayText}
            </span>
            {value.length > 1 && <Tooltip
              isOpen={tooltipOpen}
              toggle={() => setTooltipOpen(!tooltipOpen)}
              target={tooltipId}
              placement="top"
            >
              {value.join(", ")}
            </Tooltip>}
          </Box>
        );
      },
    },


    {
      accessorKey: "offerNames",
      header: "Offers",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        const [open, setOpen] = useState(false);
        if (!Array.isArray(value) || value.length === 0) return "-";

        const displayText = value.length > 1 ? `${value[0]}, ...` : value[0];
        const tooltipId = `offer-tooltip-${cell.row.id}`;

        return (
          <Box>
            <span id={tooltipId} style={{ cursor: value.length > 1 ? "pointer" : "auto" }}>
              {displayText}
            </span>
            {value.length > 1 && <Tooltip
              isOpen={open}
              toggle={() => setOpen(!open)}
              target={tooltipId}
              placement="top"
            >
              {value.join(", ")}
            </Tooltip>}
          </Box>
        );
      }
    },
    {
      accessorKey: `formattedDates`,
      header: "Created Date",
      Cell: ({ row }) => formattedDates[row.index],

    },
    {
      accessorKey: "createdBy",
      header: "Created By",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
  ]
  return column
}

export const offerListForPolicy = (grant, charge, usage, grantsCount, chargeCount, usageCount, handleDelete) => {
  const column = [
    {
      accessorKey: 'offerName',
      header: "Offer Name",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "serviceName",
      header: "Service Name",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "offerCode",
      header: "Code",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorFn: (offer, index) => `${grantsCount[index]} ${grant[index]} ${chargeCount[index]} ${charge[index]} ${usageCount[index]} ${usage[index]} `,
      header: "Rate Plan",
      Cell: ({ cell }) => {
        const attributes = cell.getValue()
        const [grantsCount, grant, chargeCount, charge, usageCount, usage] = attributes.split(' ')
        return [grant, charge, usage]?.map((val) => { return val ? <span className='me-1'><StatusBadge value={val} /></span> : null; })

        // return (<RatePlanOrAttributesColumn grant={grant} grantsCount={grantsCount} charge={charge} chargeCount={chargeCount} usageCount={usageCount} usage={usage} offerOrPolicy={true} />)
      },
      size: 275
    },
    {
      accessorKey: "GlobalScope",
      header: "Global Scope",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "validityFrom",
      header: "Offer Starts On",
      Cell: ({ cell }) => formatCellValue(cell.getValue(), val => formatDateForDisplay(val))
    },
    {
      accessorKey: "validityTo",
      header: "Offer Ends On",
      Cell: ({ cell }) => formatCellValue(cell.getValue(), val => formatDateForDisplay(val))
    },
    {
      id: 'delete',
      header: "",
      Cell: ({ row }) => {
        return (<i data-testid="delete" role="button" className="ri-delete-bin-5-line text-danger fs-16" onClick={() => handleDelete(row?.original?.offerCode)}></i>)
      },
      size: 60
    },
  ]
  return column
}

export const partnerListForPolicy = (dispatch, setPartnerDeleted) => {
  const column = [
    {
      accessorKey: 'extractedId',
      header: "Partner ID",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "businessName",
      header: "Business Name",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "type",
      header: "Type",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "email",
      header: "Email",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "phone",
      header: "Phone",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: "createdOn",
      header: "Created On",
      Cell: ({ cell }) => formatCellValue(cell.getValue(), val => formatDateForDisplay(val))
    },
    {
      accessorKey: "validityTo",
      header: "Account Balance",
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      id: 'delete',
      header: "",
      Cell: ({ row }) => {
        return (<i data-testid="delete" role="button" className="ri-delete-bin-5-line text-danger fs-16" onClick={() => {
          dispatch({
            type: "REMOVE_PARTNER",
            payload: row.original.extractedId,
          });
          setPartnerDeleted(true);
        }}></i>)
      },
      size: 60
    },
  ]
  return column
}